import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", _vm._g(_vm._b({
    on: {
      open: _vm.onOpen,
      close: _vm.onClose
    }
  }, "el-dialog", _vm.$attrs, false), _vm.$listeners), [_c("el-form", {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      model: _vm.ruleForm,
      rules: _vm.rules,
      size: "small",
      "label-width": "130px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "昵称",
      prop: "name"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.ruleForm.name,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "name", $$v);
      },
      expression: "ruleForm.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "手机号",
      prop: "phoneNum"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.ruleForm.phoneNum,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "phoneNum", $$v);
      },
      expression: "ruleForm.phoneNum"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "所属公司",
      prop: "company"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      remote: "",
      "reserve-keyword": "",
      placeholder: "请输入关键词",
      "remote-method": _vm.remoteMethod,
      loading: _vm.companyLoading
    },
    model: {
      value: _vm.ruleForm.company,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "company", $$v);
      },
      expression: "ruleForm.company"
    }
  }, _vm._l(_vm.companyList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.companyName,
        value: item.companyName
      }
    });
  }), 1), _c("el-button", {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      icon: "el-icon-plus"
    },
    on: {
      click: _vm.goCompany
    }
  })], 1)]), _c("el-form-item", {
    attrs: {
      label: "账户开通时间",
      prop: "startTime"
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      disabled: _vm.editType == 3 && _vm.ruleForm.status != 3 && _vm.ruleForm.status != 2 || _vm.editType == 1,
      "value-format": "yyyy-MM-dd HH:mm:ss",
      type: "datetime",
      "picker-options": _vm.pickerOptions,
      placeholder: "选择日期时间"
    },
    model: {
      value: _vm.ruleForm.startTime,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "startTime", $$v);
      },
      expression: "ruleForm.startTime"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "开通天数",
      prop: "days"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: _vm.editType == 1 && _vm.editType != 3
    },
    model: {
      value: _vm.ruleForm.days,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "days", _vm._n($$v));
      },
      expression: "ruleForm.days"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "金额",
      prop: "amount"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: _vm.editType == 1 && _vm.editType != 3
    },
    model: {
      value: _vm.ruleForm.amount,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "amount", _vm._n($$v));
      },
      expression: "ruleForm.amount"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "城市",
      prop: "city"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      placeholder: "请选择"
    },
    model: {
      value: _vm.ruleForm.city,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "city", $$v);
      },
      expression: "ruleForm.city"
    }
  }, _vm._l(_vm.cityList, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.name,
        value: item.name
      }
    });
  }), 1)], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "mini"
    },
    on: {
      click: _vm.close
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      size: "mini",
      type: "primary",
      loading: _vm.disLoading
    },
    on: {
      click: _vm.handelConfirm
    }
  }, [_vm._v("确 定")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };